import { createPermission } from '@backstage/plugin-permission-common';


export const featureFlagsReadPermission = createPermission({
  name: 'feature-flags-manager.read',
  attributes: { action: 'read' },
});

export const featureFlagsCreatePermission = createPermission({
  name: 'feature-flags-manager.create',
  attributes: { action: 'create' },
});

export const featureFlagsUpdatePermission = createPermission({
  name: 'feature-flags-manager.update',
  attributes: { action: 'update' },
});

export const featureFlagsProductionUpdatePermission = createPermission({
  name: 'feature-flags-production.update',
  attributes: { action: 'update' },
});

export const featureFlagsPermissions = [
  featureFlagsReadPermission,
  featureFlagsCreatePermission,
  featureFlagsUpdatePermission,
  featureFlagsProductionUpdatePermission
];
